import { Component, computed, input, output } from '@angular/core';

export type OrderFilterColor =
  | 'waitingForApproval'
  | 'processing'
  | 'done'
  | 'rejected'
  | 'collected';

// Tailwind safelist — these classes are composed dynamically via `activeClasses`
// and must remain visible to Tailwind's content scanner:
// bg-waitingForApproval-soft border-waitingForApproval text-waitingForApproval
// bg-processing-soft border-processing text-processing
// bg-done-soft border-done text-done
// bg-rejected-soft border-rejected text-rejected
// bg-collected-soft border-collected text-collected

@Component({
  selector: 'app-order-filter-button',
  standalone: true,
  templateUrl: './order-filter-button.component.html',
})
export class OrderFilterButton {
  label = input.required<string>();
  count = input.required<number>();
  active = input.required<boolean>();
  color = input.required<OrderFilterColor>();
  hasUnseen = input(false);
  select = output<void>();

  protected activeClasses = computed(
    () => `bg-${this.color()}-soft border-${this.color()} text-${this.color()} shadow`
  );
}
